<!DOCTYPE html>
<template>
<div class="dash"
     v-if="userData">

  <div class="sidemenu">
    <div>
      <div class="uppercaseheader">My profile</div>
      <div>
        {{asFullName(userData.name)}}
      </div>
      <div>
        <VerificationBadge :status="userData.verified" />
      </div>
    </div>

    <div v-for="s in userAttributeSections"
         :key="s.id">
      <div class="uppercaseheader">{{s.text}}</div>
      <Pillgroup :items="s.items"
                 :truncate="3" />
    </div>

    <div>
      <div class="uppercaseheader">My accepted projects</div>
      <b-list-group>
        <b-list-group-item v-for="p in myProjects"
                           :key="p.id"
                           size="sm"
                           :active="p == project"
                           @click="openProject(p)"
                           button>{{p.name}}
        </b-list-group-item>
      </b-list-group>
      <div v-if="myProjects.length == 0">
        No projects yet
      </div>
    </div>

    <a href="https://connect.stripe.com/express/oauth/authorize?redirect_uri=https://www.getblueteam.com/dashboard&client_id=ca_H2hUR5iif9POmHVGs71gppSUWm3LZCrk&state={STATE_VALUE}"
    target="_blank"><img src="../assets/stripe-blue-on-light.png"
    alt="Connect to Stripe" style="width: 90%; height: 90%;"></a>

  </div>



  <div class="content"
       v-if="userData.verified && userData.realPerson">

    <ProjectsTable v-if="!project"
                   :userData="userData"
                   @open-project="openProject" />

    <ProjectDetails v-if="project"
                    :userData="userData"
                    :project="project"
                    @close="closeProject" />

  </div>

</div>
</template>

<script>
//Firebase
const firebase = require( '@/firebaseConfig.js' )
const users = firebase.db.collection( 'users' )
//Components
import Pillgroup from '@/components/Pillgroup.vue'
import VerificationBadge from '@/components/VerificationBadge.vue'
import ProjectsTable from '@/components/provider/ProjectsTable.vue'
import ProjectDetails from '@/components/provider/ProjectDetails.vue'
// Mixins
import { Formatter, Skills, Status } from '@/mixins/Mixins.js'
export default {
  name: 'ProviderDashboard',
  components: {
    Pillgroup,
    ProjectsTable,
    ProjectDetails,
    VerificationBadge,
  },
  mixins: [ Formatter, Skills, Status ],
  props: {
    user: Object,
  },
  data() {
    return {
      userRef: null,
      userData: null,
      projects: [],
      projectRef: null,
      project: null,
    }
  },
  firestore: {
    skills: firebase.db.collection( 'skills' ),
    preferences: firebase.db.collection( 'preferences' ),
    projects: firebase.db.collection( 'projects' ),
  },
  watch: {
    user: {
      immediate: true,
      handler( user ) {
        if ( user ) {
          this.userRef = users.doc( user.uid )
          this.$bind( 'userData', this.userRef )
        }
      },
    },
    projectRef: {
      immediate: true,
      handler( projectRef ) {
        if ( projectRef ) {
          this.$bind( 'project', projectRef )
        } else {
          this.project = null
        }
      },
    },
  },
  computed: {
    userAttributes() {
      return [].concat( this.user.skills )
        .concat( this.user.goals )
        .concat( this.user.preferences )
    },
    userAttributeSections() {
      let s = [
        { text: 'My skills', items: this.userData.skills },
        { text: 'My preferences', items: this.userData.preferences },
      ]
      return s.filter( s => s.items.length > 0 )
    },
    myProjects() {
      // All projects that I have been approved for
      let uid = this.userRef.id
      return this.projects.filter( p => {
        return ( p.providers &&
          p.providers.accepted.find( a => a.id == uid ) )
      } )
    }
  },
  methods: {
    openProject( project ) {

      this.projectRef = project.ref
    },
    closeProject() {
      this.projectRef = null
    },

  }
}
</script>


<style scoped lang="scss">
@import "@/styles/global.scss";

.dash {
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: 1fr 5fr;
    grid-column-gap: 1rem;
    min-height: 70vh;
    color: $primary;

    .sidemenu {
        display: grid;
        grid-row-gap: 2rem;
        align-content: flex-start;
    }

    .content {
        background: theme-color-level('primary', -12);
        padding: 2rem;
        border-radius: 1rem;
    }

    .details {
        display: grid;
        padding: 1rem;

        > div {
            display: grid;
            padding: 0.5rem 0;
            grid-auto-flow: column;
            grid-template-columns: 1fr 3fr;
            border-bottom: 1px solid theme-color-level('primary',-11);
            align-items: center;
        }
    }
}
</style>
